import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@mui/styles';
import { Typography, Grid } from '@mui/material';

const useStyles = makeStyles((theme) => ({
	root: {
		backgroundColor: theme.palette.background.default,
	},
	inner: {
		padding: theme.spacing(6, 3),
		width: theme.breakpoints.values.lg,
		maxWidth: '100%',
		margin: '0 auto',
	},
	media: {
		'& img': {
			width: '100%',
			height: 'auto',
		},
	},
}));

const SourceFiles = (props) => {
	const { className, ...rest } = props;

	const classes = useStyles();

	return (
		<div {...rest} className={clsx(classes.root, className)}>
			<div className={classes.inner}>
				<Grid alignItems="center" container justifyContent="space-between">
					<Grid item lg={3} md={6} xs={12}>
						<Typography gutterBottom variant="h3">
							Source Files
						</Typography>
						<Typography variant="subtitle2">
							We've included the source Sketch & Figma files so
							you can get creative! We designed all components
							with Symbols in Sketch which allows you to change
							the main colors as you like.
						</Typography>
					</Grid>
					<Grid className={classes.media} item lg={4} md={6} xs={12}>
						<img
							alt="User flows"
							src="./images/presentation/source_files.png"
						/>
					</Grid>
				</Grid>
			</div>
		</div>
	);
};

SourceFiles.propTypes = {
	className: PropTypes.string,
};

export default SourceFiles;
